import React from 'react';
import { Button, Modal } from 'app/components';
import { Plus, Minus, CheckCircle } from '@phosphor-icons/react';
import './style';

const CheckInModal = ({
  isOpen,
  config,
  ticketCount,
  checkInCount,
  total_quantity,
  incrementCheckInCount,
  decrementCheckInCount,
  handleCheckIn,
  onClose,
}) => {
  return (
    <Modal
      size="medium"
      isOpen={isOpen}
      primaryText={'Checkin'}
      title="Ticket Details"
      hasClose={true}
      onClose={onClose}
      className="checkIn-modal"
    >
      <div className="flex flex-col gap-8 w-auto">
        <div className="flex flex-col gap-3">
          <div className="flex flex-row justify-between">
            <h6>Name</h6>
            <h6 className="text-base font-medium">{config?.event_name}</h6>
          </div>
          <div className="flex flex-row justify-between">
            <h6>Category</h6>
            <h6 className="text-base font-medium">{config?.ticket_details[0]?.category}</h6>
          </div>
          <div className="flex flex-row justify-between">
            <h6>No of Tickets</h6>
            <h6 className="text-base font-medium">
              {total_quantity} Ticket{total_quantity > 1 ? '(s)' : ''}
            </h6>
          </div>
          <div className="flex flex-row justify-between">
            <h6>Booking Id </h6>
            <h6 className="text-base font-medium">{config?.bookingId}</h6>
          </div>
        </div>

        {ticketCount > 0 && (
          <div className="flex justify-center p-4 bg-light-green rounded-lg gap-3">
            <CheckCircle size={24} fill="#009D64" weight="fill" />
            <p className="text-16 font-medium">{ticketCount} Ticket(s) already checked in.</p>
          </div>
        )}

        {total_quantity > 1 && (
          <div className="flex flex-col gap-2">
            <p>How many tickets do you want to check in?</p>
            <div className="flex flex-row px-5 py-3 justify-between items-center h-[56px] w-[156px] border-2 border-gray-200 rounded-xl">
              <Minus
                size={24}
                className={`cursor-pointer ${checkInCount === 1 ? 'text-grey-50' : ''}`}
                onClick={decrementCheckInCount}
              />
              <h5>{checkInCount}</h5> 
              <Plus
                size={24}
                className={`cursor-pointer ${checkInCount === total_quantity - ticketCount ? 'text-grey-50' : ''}`}
                onClick={incrementCheckInCount}
              />
            </div>
          </div>
        )}
        <Button className="w-full" onClick={handleCheckIn}>
          Check In
        </Button>
      </div>
    </Modal>
  );
};


export default CheckInModal;
